






















































































































import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import type { Route } from "@/@types/route-info/v2/v2.routes";
import IdCopyComponent from "@/components/app/id-copy-component.vue";
import MiniPoster from "@/components/app/shared/image/mini-poster.vue";
import RouteInfoV2RouteTableHeader from "./route-info-v2-route-table-header.vue";
import BSettingDd from "@/components/app/shared/btn&dd/b-setting-dd.vue";
import StandartTable from "@/components/tables/standart-table.vue";

@Component({
  components: {
    IdCopyComponent,
    MiniPoster,
    RouteInfoV2RouteTableHeader,
    BSettingDd,
    StandartTable,
  },
})
class RouteInfoV2RouteList extends Vue {
  @Prop({ type: Array, default: () => [] }) routes!: Route[];
  @Prop({ type: Boolean, default: false }) deleteRoute!: boolean;
  @Prop({ type: Boolean, default: false }) isActivating!: boolean;

  @Inject("routeFolder") routeFolder!: string;

  formatDate(date?: Date) {
    if (!date) return "—";
    return new Date(date).toLocaleDateString();
  }

  async copyId(id: string) {
    await navigator.clipboard.writeText(id);
    this.$bvToast.toast("ID copied", {
      autoHideDelay: 1000,
      solid: true,
      variant: "success",
    });
  }

  getRouteImage(route: Route): { img: string; folder: string } {
    const fallback = { img: "", folder: this.routeFolder };
    if (!route.src) return fallback;
    const map: Array<{ name: string; folder: string }> = [
      { name: "image", folder: `${this.routeFolder}/image/hd` },
      { name: "background", folder: `${this.routeFolder}/background/hd` },
      { name: "poster", folder: `${this.routeFolder}/poster/hd` },
      {
        name: "vertical_poster",
        folder: `${this.routeFolder}/vertical_poster/hd`,
      },
      {
        name: "horizontal_poster",
        folder: `${this.routeFolder}/horizontal_poster/hd`,
      },
    ];
    for (const item of map) {
      const val = (route.src as any)[item.name];
      if (val) return { img: val, folder: item.folder };
    }
    return fallback;
  }

  totalStay(route: Route): string {
    const cities = route.cities || [];
    let totalMinutes = 0;
    for (const c of cities) {
      if (c.stayDuration) {
        totalMinutes += Math.round((c.stayDuration || 0) * 60);
      }
    }
    if (!totalMinutes) return "—";
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    const parts: string[] = [];
    if (h) parts.push(`${h}ч`);
    if (m) parts.push(`${m}мин`);
    return parts.join(" ");
  }

  typeVariant(type: Route["type"]) {
    switch (type) {
      case "railway":
        return "primary";
      case "river":
        return "info";
      case "combined":
        return "warning";
      default:
        return "secondary";
    }
  }

  statusVariant(status: Route["status"]) {
    switch (status) {
      case "active":
        return "success";
      case "draft":
        return "secondary";
      case "inactive":
        return "warning";
      case "archived":
        return "dark";
      default:
        return "secondary";
    }
  }
}
export default RouteInfoV2RouteList;
